/* eslint-disable */
// The ONE place a "Moved to order" lock is derived on the client (Collection
// C2, Conv #61). The server writes the three lock keys into the season mirror
// — data.selections['<season>'] = { …, locked_since, left_stage, unlocked_at }
// (collection-c1-v1, _apply_selection_mirror) — and _dev_lock_guard refuses a
// stage write on a locked development with P0403. This file reads that mirror
// and nothing else: no query, no RPC, never `procurement` (the chip's axis).
//
// Why locked_since, not procurement: an open lock episode ⇔ procurement set by
// construction (C1), so today they agree on every row; locked_since is the key
// the server writes FOR the lock and it carries the date the card shows. If
// they ever disagree, the lock key wins here and the disagreement is a C1 bug
// to report, never to paper over.
//
// The FIXED season (SELECTION_SEASON), never resolveSelectionDecision's
// newest-season pick — a lock is per round.
import { SELECTION_SEASON } from '../components/developments/selectionSeason';

export const LOCK_KEY = '_moved_to_order';
export const LOCK_LABEL = 'Moved to order';
export const LOCK_NOTE_DAYS = 30;                 // D7 — "Was in the collection" window

const LEFT_STAGE_LABEL = {
  _done: 'Done',
  'Hand made': 'Hand made sample stage',
  'Color sample': 'Color sample stage',
  Drawing: 'Drawing stage',
  _stopped: 'Stopped',
};

/** The three lock keys of ONE season object, or null when it carries none.
 *  Tolerant: null / array / non-object → null; a legacy 4-key object → null. */
export function readLockAt(seasonObj) {
  if (!seasonObj || typeof seasonObj !== 'object' || Array.isArray(seasonObj)) return null;
  const lockedSince = typeof seasonObj.locked_since === 'string' ? seasonObj.locked_since : null;
  const unlockedAt  = typeof seasonObj.unlocked_at  === 'string' ? seasonObj.unlocked_at  : null;
  const leftStage   = typeof seasonObj.left_stage   === 'string' ? seasonObj.left_stage   : null;
  if (!lockedSince && !unlockedAt) return null;
  return { lockedSince, leftStage, unlockedAt };
}

/** Dual-read, the chip's shape: the projection lifts data->selections to the
 *  top level; a full-row load nests it. */
export function devLock(dev) {
  const sel = dev?.selections || dev?.data?.selections;
  if (!sel || typeof sel !== 'object' || Array.isArray(sel)) return null;
  return readLockAt(sel[SELECTION_SEASON]);
}

export function devIsMovedToOrder(dev) {
  return !!devLock(dev)?.lockedSince;
}

/** The stage the development left at, as a label. null bucket = the shells (D3). */
export function devLeftStageLabel(dev) {
  const ls = devLock(dev)?.leftStage;
  return (ls && LEFT_STAGE_LABEL[ls]) || 'No stage';
}

/** D7 — unlocked within the last 30 days and not locked again. */
export function devWasInCollection(dev, now = Date.now()) {
  const lock = devLock(dev);
  if (!lock || lock.lockedSince || !lock.unlockedAt) return false;
  const t = new Date(lock.unlockedAt).getTime();
  if (!Number.isFinite(t)) return false;
  const age = now - t;
  return age >= 0 && age <= LOCK_NOTE_DAYS * 86400000;
}

export const LOCK_MESSAGE = 'Locked — this development is in the SS2027 order. Stage and status are frozen.';

/** The guard's refusal (P0403 dev_locked) as words; null for any other error. */
export function lockErrorMessage(error) {
  if (!error) return null;
  const code = error.code || error.sqlstate;
  const msg = String(error.message || error.details || '');
  return (code === 'P0403' || msg.includes('dev_locked')) ? LOCK_MESSAGE : null;
}
